
export default "/assets/globe-alt-mini.52e73ebf.svg"